export default function(data){
    return data.forEach(ele => {
        ele.numberOfWords = ele.currentTableNumber - ele.lastTableNumber;
        ele.money = (ele.numberOfWords * ele.unitPrice).toFixed(2);
    });
}